module.exports = __webpack_public_path__ + "img/clothes_2.b1113021.jpg";